import React, { useEffect,useState } from "react"; 
import "./s3.css"
import { useNavigate } from "react-router-dom";
import { checkPermissions } from "../../../Services/User/User";
import {getStorageContent,fetchFolderContent} from "../../../Services/s3Service"
import FileActions from "./fileActions"
function S3Component() { 
    const [folders,setFolders]=useState([])
    const [files,setFiles]=useState([]) 
    const [cfpath,setCfpath]=useState('')
    const [breadCrumbs,setBreadCrubs]=useState([])
    const navigate    = useNavigate();
    useEffect(()=>{
        getBaseLevelData()
    },[])
    useEffect(() => {
    if(!checkPermissions('s3_access_page') || !checkPermissions('developer_navigation')){ 
        navigate('/')
        }
    },[])
    const getData=(bCrub,index)=>{ 
        
        setCfpath(bCrub.key)
        fetchFolderContent(bCrub.key).then((data)=>{
            if(data.status){
                setFolders(data.data.folders)
                setFiles(data.data.files)
            }else{
                setFolders([])
                setFiles([])
            }
        })
        console.log(breadCrumbs.slice(0, index))
        setBreadCrubs(breadCrumbs.slice(0, index+1))
    }
    const getBaseLevelData=()=>{
        setBreadCrubs([])
        setCfpath('')
        getStorageContent().then((data)=>{
            if(data.status){
                setFolders(data.data.folders)
                setFiles(data.data.files)
            }else{
                setFolders([])
                setFiles([])
            }
        }) 
    }
    const getFolderContent=(folderPath,ignorePath=null)=>{ 
        var path=""
        if(cfpath!=""){
            path=cfpath+`/${folderPath}`
        }else{
            setCfpath(folderPath)
            path=folderPath
        }  
        path= path.replace(/\/+$/, "") 
        setCfpath(path) 
        setBreadCrubs([...breadCrumbs,{bname:folderPath,key:path}]) 
        fetchFolderContent(path).then((data)=>{
            if(data.status){
                setFolders(data.data.folders)
                setFiles(data.data.files)
            }else{
                setFolders([])
                setFiles([])
            }
        })
    }
  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>S3</h1>
          <nav>
            <ol className="breadcrumb">
                <li onClick={getBaseLevelData} className="cursor-pointer breadcrumb-item" >Home</li> 
                {
                    breadCrumbs.map((bCrub,index)=>{
                        return(<>
                          <li onClick={()=>{getData(bCrub,index) }}  className="cursor-pointer breadcrumb-item" >{bCrub.bname}</li> 
              
                        </>)
                    })
                }
            </ol>
            </nav>
        </div>
        <section className="section">
        <div className="row">
            <div className="col-lg-12">
            <ul className="list-group mt-4">
                {folders.map((folder_name,index)=>{
                    return(<>
                    <li key={index} onClick={()=>{getFolderContent(folder_name.replace(/\/+$/, "") )}} className="cursor-pointer list-group-item d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-folder-fill text-warning me-2" style={{fontSize:"24px"}} ></i>
                            <span>{folder_name.replace(/\/+$/, "") }</span>
                        </div> 
                    </li>
                    </>)
                })} 

                {
                    files.map((file,index)=>{ 
                        return(<>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
	<div className="d-flex align-items-center">
		<i className="bi bi-file-earmark-image-fill text-info me-2" style={{fontSize:"24px"}}></i>
		<span>{file.name} ({file.size})</span>
	</div>
    <FileActions fileKey={`${cfpath}/${file.name}`}/> 
</li>
                        </>)
                    })
                }
                </ul>
            </div>
        </div>

       
        </section>
      </main>
    </div>
  );
}
export default S3Component;
